import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

/**
 * Usado pelo grupo "Administração" da sidebar.
 *
 * As animações `accordion-down`/`accordion-up` já estão no `tailwind.config.ts`
 * (com `tailwindcss-animate` instalado) — basta aplicá-las no `Content`:
 * `data-[state=open]:animate-accordion-down`.
 */
const Collapsible = CollapsiblePrimitive.Root;
const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;
const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
